module.exports = __webpack_public_path__ + "img/admin_adv_08.ee78325d.png";